import { Configuration, LogLevel, RedirectRequest } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId:                process.env.REACT_APP_AZURE_CLIENT_ID  || '',
    authority:               `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || 'common'}`,
    redirectUri:             process.env.REACT_APP_AZURE_REDIRECT_URI || `${window.location.origin}/auth/callback`,
    postLogoutRedirectUri:   window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation:          'sessionStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) return;
        if (process.env.NODE_ENV === 'development') {
          console.log(`[MSAL][${LogLevel[level]}] ${message}`);
        }
      },
    },
  },
};

export const loginRequest: RedirectRequest = {
  scopes:  ['User.Read', 'Mail.Send', 'openid', 'profile', 'email'],
  // No `prompt` — let Azure AD silently reuse its own browser SSO session when
  // one exists, rather than forcing a fresh credential/MFA challenge on every
  // sign-in. How long that session lasts before re-challenging on its own is
  // governed by the tenant's Conditional Access "sign-in frequency" policy in
  // Entra ID, not by this app.
};
